export function calculateTextWidth(text: string, font: string, fontSize: string): number {
  // Create a temporary span element
  const span = document.createElement('span');

  // Set the text and font
  span.textContent = text;
  span.style.fontFamily = font;
  span.style.fontSize = fontSize;

  // Set the span to be invisible and append it to the body
  span.style.visibility = 'hidden';
  span.style.position = 'absolute';
  span.style.whiteSpace = 'nowrap';
  document.body.appendChild(span);

  // Measure the text width
  const width = span.offsetWidth;

  // Remove the span element
  document.body.removeChild(span);

  return width;
}

export function calculateRichTextHeightForJointJs(
  htmlContent: string,
  font: string,
  fontSize: string,
  lineHeight: string,
  width?: number,
): number {
  // Create a temporary div element
  const div = document.createElement('div');

  // Apply font styles
  div.style.fontFamily = font;
  div.style.fontSize = fontSize;
  if (lineHeight) {
    div.style.lineHeight = lineHeight;
  }

  // Set width constraint to enable line breaks
  if (width) {
    div.style.width = `${width}px`;
  }

  // Set the innerHTML to preserve rich text structure
  div.innerHTML = htmlContent;

  // Set the div to be invisible and append it to the body
  div.style.visibility = 'hidden';
  div.style.position = 'absolute';
  div.style.left = '-9999px'; // Prevent layout shifts
  div.style.top = '-9999px';
  div.style.pointerEvents = 'none'; // Ensure it doesn't interfere with user actions
  div.style.overflow = 'hidden'; // Prevent overflow effects

  div.innerHTML = `
  <style>
    p:first-of-type { margin-top: 0 !important; }
  </style>
  ${htmlContent}
`;

  document.body.appendChild(div);

  // Measure text height
  const height = div.offsetHeight;

  // Remove the element
  document.body.removeChild(div);

  return height;
}
